// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const RegistrationError = t.struct({
    code: t.Number,
    description: t.String,
    id: t.Number
}, {
    name: 'RegistrationError',
    strict: true
});

export const getDefaultState = () => new RegistrationError({
    code: 0,
    description: '',
    id: 0
});

export default RegistrationError;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/registration-error.js